(function () {
  'use strict';

  // ==========================================================================
  //  CONFIGURACION
  // ==========================================================================

  // UNICO valor que hay que mantener a mano: el handle del producto del fee.
  // De el se leen, en caliente, tanto el variant id como los selling plans.
  var FEE_HANDLE = 'delivery-fee';

  // Valor inicial de la variante. Si deja de existir (producto duplicado,
  // variante recreada), el script lo corrige solo leyendo el producto.
  var FEE_VARIANT = 47267937812720;

  // Override manual plan de la bolsa -> plan del fee.
  // Vacio = todo dinamico. Solo rellenar si dos planes con nombres
  // parecidos se emparejan mal y hay que forzar una pareja concreta.
  var PLAN_MAP = {};

  // true  = si el fee no puede quedar recurrente, se bloquea el checkout.
  // false = se deja pasar el pedido y solo se marca el carrito.
  var BLOQUEAR_CHECKOUT_SI_FALLA = false;

  var FEE_NOMBRE = 'Delivery Fee';

  var ZONA_B = ['33319','33060','33061','33062','33063','33064','33065','33066','33067','33068','33069','33071','33072','33073','33074','33075','33076','33077','33093','33097','33321','33323','33351','33401','33403','33404','33405','33406','33407','33408','33409','33410','33411','33413','33415','33417','33418','33426','33427','33428','33431','33432','33433','33434','33435','33436','33437','33441','33442','33443','33444','33445','33446','33460','33461','33462','33463','33466','33467','33472','33473','33480','33481','33482','33483','33484','33486','33487','33496','33498','33499'];

  // ==========================================================================
  //  UTILIDADES
  // ==========================================================================

  function log(msg, extra) {
    if (window.GT_DEBUG) console.log('[delivery-fee] ' + msg, extra || '');
  }

  function getZip() {
    var m = document.cookie.match(/sac_lastzipcode=(\d{5})/);
    return m ? m[1] : null;
  }

  function enZonaB() {
    var z = getZip();
    return z && ZONA_B.indexOf(z) !== -1;
  }

  async function api(url, body) {
    var opt = { method: 'GET', headers: { 'Content-Type': 'application/json' } };
    if (body) { opt.method = 'POST'; opt.body = JSON.stringify(body); }
    var r = await fetch(url, opt);
    if (!r.ok) {
      var txt = '';
      try { txt = await r.text(); } catch (e) {}
      throw new Error(url + ' -> HTTP ' + r.status + ' ' + txt.slice(0, 200));
    }
    return r.json();
  }

  var getCart     = function ()      { return api('/cart.js'); };
  var borrarLinea = function (key)   { return api('/cart/change.js', { id: key, quantity: 0 }); };

  var anadirFee = function (plan) {
    var item = { id: FEE_VARIANT, quantity: 1 };
    if (plan) item.selling_plan = Number(plan);
    return api('/cart/add.js', { items: [item] });
  };

  var cambiarPlan = function (key, plan) {
    var body = { id: key, quantity: 1 };
    body.selling_plan = plan ? Number(plan) : null;
    return api('/cart/change.js', body);
  };

  // Deja constancia en el pedido de si el fee quedo recurrente o no.
  // Aparece en el admin del pedido como atributo del carrito.
  var estadoEscrito = null;
  async function marcarEstado(estado) {
    if (estadoEscrito === estado) return;
    estadoEscrito = estado;
    try {
      await api('/cart/update.js', { attributes: { '_gt_fee': estado } });
    } catch (e) { log('no se pudo marcar el estado', e.message); }
  }

  // El tope de recargas solo debe frenar bucles reales. Cada pasada que
  // termina sin tocar nada demuestra que no hay bucle: se reinicia.
  function reiniciarTopeRecargas() {
    try { sessionStorage.removeItem('gt_fee_reloads'); } catch (e) {}
  }

  function refrescarCarrito() {
    if (window.location.pathname.indexOf('/cart') === 0) {
      // Anti-bucle: como maximo dos recargas por sesion de pagina.
      var n = Number(sessionStorage.getItem('gt_fee_reloads') || 0);
      if (n < 2) {
        sessionStorage.setItem('gt_fee_reloads', String(n + 1));
        window.location.reload();
      } else {
        log('recargas agotadas, no se recarga otra vez');
      }
      return;
    }
    var cf = document.querySelector('cart-form');
    if (cf) cf.dispatchEvent(new Event('cart-updated'));
    else document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  // ==========================================================================
  //  RESOLUCION DEL PLAN DEL FEE  (sin ids quemados)
  // ==========================================================================

  // Texto normalizado de un selling plan: nombre + valores de sus opciones.
  function etiqueta(sp) {
    if (!sp) return '';
    var partes = [sp.name || ''];
    (sp.options || []).forEach(function (o) {
      partes.push(typeof o === 'string' ? o : (o.value || ''));
    });
    return partes.join(' ').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  }

  // Rango de frecuencia deducido del texto. 1 = mas frecuente.
  function rango(texto) {
    if (/every other week|other week|biweek|bi week|2 week|two week|quincen/.test(texto)) return 2;
    if (/week|semanal|semana/.test(texto)) return 1;
    if (/month|mensual|mes/.test(texto)) return 3;
    return 9;
  }

  var _feeProd = null;
  async function cargarFee() {
    if (_feeProd) return _feeProd;
    var prod = await api('/products/' + FEE_HANDLE + '.js');

    var lista = [];
    (prod.selling_plan_groups || []).forEach(function (g) {
      (g.selling_plans || []).forEach(function (p) { lista.push(p); });
    });
    if (!lista.length) console.warn('[delivery-fee] el producto ' + FEE_HANDLE + ' no tiene selling plans');

    // Autocorreccion del variant id.
    var vs = prod.variants || [];
    var existe = vs.some(function (v) { return v.id === FEE_VARIANT; });
    if (!existe && vs.length) {
      console.warn('[delivery-fee] la variante ' + FEE_VARIANT + ' ya no existe; se usa ' + vs[0].id);
      FEE_VARIANT = vs[0].id;
    }

    _feeProd = { planes: lista, variantes: vs };
    return _feeProd;
  }

  async function planesDelFee() {
    return (await cargarFee()).planes;
  }

  // Devuelve el id del plan del fee que corresponde al plan de la bolsa.
  async function resolverPlanFee(planBolsa) {
    if (!planBolsa) return null;
    var id = String(planBolsa.id);

    // 1) Override manual.
    if (PLAN_MAP[id]) return PLAN_MAP[id];

    var planes;
    try { planes = await planesDelFee(); }
    catch (e) { console.warn('[delivery-fee] no se pudo leer ' + FEE_HANDLE + ': ' + e.message); return null; }

    // 2) El fee esta en el mismo grupo que la bolsa: mismo id.
    for (var i = 0; i < planes.length; i++) {
      if (String(planes[i].id) === id) return id;
    }

    var objetivo = etiqueta(planBolsa);

    // 3) Misma etiqueta exacta.
    for (var j = 0; j < planes.length; j++) {
      if (etiqueta(planes[j]) === objetivo) return String(planes[j].id);
    }

    // 4) Misma frecuencia deducida del texto.
    var r = rango(objetivo);
    if (r !== 9) {
      for (var k = 0; k < planes.length; k++) {
        if (rango(etiqueta(planes[k])) === r) return String(planes[k].id);
      }
    }

    console.warn('[delivery-fee] sin plan equivalente para "' + objetivo + '" (plan bolsa ' + id + ')');
    return null;
  }

  // ==========================================================================
  //  SINCRONIZACION DEL FEE  (con candado)
  // ==========================================================================

  var enCurso = null;
  var repetir = false;

  function sincronizarFee() {
    if (enCurso) { repetir = true; return enCurso; }
    enCurso = _sincronizar()
      .catch(function (e) { console.warn('[delivery-fee] fallo la sincronizacion:', e.message); })
      .then(function () {
        enCurso = null;
        if (repetir) { repetir = false; return sincronizarFee(); }
      });
    return enCurso;
  }

  async function _sincronizar() {
    var cart = await getCart();
    var feeItem = cart.items.find(function (i) { return i.variant_id === FEE_VARIANT; });
    var cambio = false;

    // Autocorreccion del handle: si el fee ya esta en el carrito, lo sabemos.
    if (feeItem && feeItem.handle && feeItem.handle !== FEE_HANDLE) {
      FEE_HANDLE = feeItem.handle;
      _feeProd = null;
      log('handle del fee corregido a ' + FEE_HANDLE);
    }

    // Leer el producto del fee (cacheado). Puede corregir el variant id.
    try {
      var varianteAntes = FEE_VARIANT;
      await cargarFee();
      if (FEE_VARIANT !== varianteAntes) {
        cart = await getCart();
        feeItem = cart.items.find(function (i) { return i.variant_id === FEE_VARIANT; });
      }
    } catch (e) {
      console.warn('[delivery-fee] no se pudo leer /products/' + FEE_HANDLE + '.js: ' + e.message);
    }

    // --- Fuera de zona B: no debe haber fee ---
    if (!enZonaB()) {
      if (feeItem) { await borrarLinea(feeItem.key); cambio = true; log('fuera de zona, fee retirado'); }
      if (cambio) refrescarCarrito(); else reiniciarTopeRecargas();
      return;
    }

    // --- Plan mas frecuente presente en el carrito ---
    var planBolsa = null;
    var mejorRango = 99;
    var hayProductos = false;

    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      if (it.variant_id === FEE_VARIANT) continue;
      hayProductos = true;
      var sp = it.selling_plan_allocation && it.selling_plan_allocation.selling_plan;
      if (!sp) continue;
      var r = rango(etiqueta(sp));
      if (r < mejorRango) { mejorRango = r; planBolsa = sp; }
    }

    // --- Carrito sin productos: fuera el fee ---
    if (!hayProductos) {
      if (feeItem) { await borrarLinea(feeItem.key); cambio = true; log('carrito vacio, fee retirado'); }
      if (cambio) refrescarCarrito(); else reiniciarTopeRecargas();
      return;
    }

    var mejorPlan = await resolverPlanFee(planBolsa);

    // Aviso fuerte: la bolsa es recurrente pero el fee se quedaria puntual.
    if (planBolsa && !mejorPlan) {
      console.error('[delivery-fee] la bolsa es recurrente pero no hay plan para el fee. ' +
                    'El fee se cobrara UNA sola vez. Plan de la bolsa: ' + planBolsa.id);
      marcarEstado('sin-plan');
    } else {
      marcarEstado(mejorPlan ? 'ok' : 'compra-puntual');
    }

    var planActual = feeItem && feeItem.selling_plan_allocation
      ? String(feeItem.selling_plan_allocation.selling_plan.id)
      : null;

    // --- Ya esta correcto ---
    if (feeItem && planActual === (mejorPlan || null) && feeItem.quantity === 1) {
      log('fee ya correcto');
      reiniciarTopeRecargas();
      return;
    }

    // --- No existe: anadirlo ---
    if (!feeItem) {
      try {
        await anadirFee(mejorPlan);
      } catch (e) {
        // El plan pudo quedar invalido tras editar los grupos en Bold.
        console.error('[delivery-fee] add.js rechazo el plan ' + mejorPlan + ': ' + e.message);
        _feeProd = null;
        await anadirFee(null);
        marcarEstado('sin-plan');
      }
      log('fee anadido', mejorPlan || 'one-time');
      refrescarCarrito();
      return;
    }

    // --- Existe con plan o cantidad equivocada ---
    try {
      await cambiarPlan(feeItem.key, mejorPlan);
      log('plan del fee corregido', mejorPlan || 'one-time');
    } catch (e) {
      log('change.js no acepto el cambio, recurriendo a borrar+anadir');
      await borrarLinea(feeItem.key);
      try { await anadirFee(mejorPlan); }
      catch (e2) { await anadirFee(null); marcarEstado('sin-plan'); }
    }
    refrescarCarrito();
  }

  // Comprobacion final: devuelve true si el estado del carrito es coherente.
  async function feeCoherente() {
    try {
      var cart = await getCart();
      var fee = cart.items.find(function (i) { return i.variant_id === FEE_VARIANT; });
      var bolsaRecurrente = cart.items.some(function (i) {
        return i.variant_id !== FEE_VARIANT && i.selling_plan_allocation;
      });
      if (!enZonaB()) return true;
      if (!bolsaRecurrente) return true;
      return !!(fee && fee.selling_plan_allocation);
    } catch (e) { return true; }
  }

  // ==========================================================================
  //  GUARDIA EN EL CHECKOUT
  // ==========================================================================

  var yendoACheckout = false;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('#CheckOut, [name="checkout"], button[type="submit"][form="cart"]');
    if (!btn || yendoACheckout) return;

    e.preventDefault();
    e.stopPropagation();
    yendoACheckout = true;
    btn.classList.add('working');

    var espera = new Promise(function (res) { setTimeout(res, 4000); });

    Promise.race([sincronizarFee(), espera])
      .then(feeCoherente)
      .then(function (ok) {
        if (!ok && BLOQUEAR_CHECKOUT_SI_FALLA) {
          yendoACheckout = false;
          btn.classList.remove('working');
          alert('We could not attach the delivery fee to your subscription. Please refresh the page and try again.');
          return;
        }
        window.location.href = '/checkout';
      });
  }, true);

  // ==========================================================================
  //  AVISOS EN PANTALLA
  // ==========================================================================

  function mostrarAvisoZona() {
    document.querySelectorAll('#gt-zona-aviso').forEach(function (e) { e.remove(); });
    var z = getZip();
    var cont = document.querySelector('.sac_embed_checked');
    if (!z || !cont || ZONA_B.indexOf(z) === -1) return;

    var div = document.createElement('div');
    div.id = 'gt-zona-aviso';
    div.style.cssText = 'margin-top:8px;padding:8px 12px;background:#fff8e1;border-left:3px solid #606c38;font-size:14px;line-height:1.4;';
    div.innerHTML = '<strong>$10 delivery fee</strong> applies to your area. It will be added to your order automatically.';
    cont.appendChild(div);
  }

  function avisoRevalidar() {
    var prev = document.getElementById('gt-revalidar');
    var z = getZip();
    var form = document.querySelector('.sac_embed, .sac_checker');
    if (z || !form) { if (prev) prev.remove(); return; }
    if (prev) return;

    var div = document.createElement('div');
    div.id = 'gt-revalidar';
    div.style.cssText = 'margin-top:8px;padding:8px 12px;background:#fff3cd;border-left:3px solid #d68910;font-size:14px;line-height:1.4;';
    div.innerHTML = 'Please check your zipcode again to confirm delivery availability for your area.';
    form.appendChild(div);
  }

  function cambiarTextoDiffCheck() {
    var a = document.querySelector('.sac_diff_check');
    if (!a) return;
    var z = getZip();
    if (!z) return;

    var span = a.querySelector('.zincode_cookie');
    if (span) span.style.display = 'none';

    Array.prototype.slice.call(a.childNodes).forEach(function (n) {
      if (n.nodeType === 3) n.nodeValue = '';
    });

    var mio = a.querySelector('.gt-difftext');
    if (!mio) {
      mio = document.createElement('span');
      mio.className = 'gt-difftext';
      a.appendChild(mio);
    }
    var nuevo = '<strong>' + z + '</strong> &mdash; Check another zipcode';
    if (mio.innerHTML !== nuevo) mio.innerHTML = nuevo;
  }

  // ==========================================================================
  //  BLOQUEO DE LOS CONTROLES DEL FEE
  // ==========================================================================

  function esFilaDelFee(row) {
    if (!row) return false;
    if (row.querySelector('[data-variant-id="' + FEE_VARIANT + '"], [href*="variant=' + FEE_VARIANT + '"]')) return true;
    if (row.dataset && String(row.dataset.variantId) === String(FEE_VARIANT)) return true;
    return row.textContent.indexOf(FEE_NOMBRE) !== -1;
  }

  var SEL_FILA = 'tr, li, .cart-item, [class*="cart-form-item"], [class*="cart-block__item"]';

  function bloquearRemoveFee() {
    document.querySelectorAll('a.remove, [data-href*="/cart/change"]').forEach(function (el) {
      if (el.dataset.gtBloqueado === '1') return;
      var row = el.closest(SEL_FILA) || (el.parentElement && el.parentElement.parentElement);
      if (!esFilaDelFee(row)) return;

      el.style.display = 'none';
      el.dataset.gtBloqueado = '1';

      row.querySelectorAll('button, a[href*="cart/change"], [data-href*="cart/change"], input').forEach(function (b) {
        if (b === el || b.dataset.gtBloqueado === '1') return;
        b.style.pointerEvents = 'none';
        b.style.opacity = '0.35';
        b.setAttribute('disabled', 'disabled');
        b.setAttribute('tabindex', '-1');
        b.dataset.gtBloqueado = '1';
      });
    });
  }

  // ==========================================================================
  //  ARRANQUE
  // ==========================================================================

  function pintarAvisos() {
    mostrarAvisoZona();
    avisoRevalidar();
    cambiarTextoDiffCheck();
    bloquearRemoveFee();
  }

  document.addEventListener('DOMContentLoaded', function () {
    sincronizarFee();
    pintarAvisos();

    var pendiente = false;
    new MutationObserver(function () {
      if (pendiente) return;
      pendiente = true;
      setTimeout(function () { pendiente = false; pintarAvisos(); }, 300);
    }).observe(document.body, { childList: true, subtree: true });
  });

  var tSync = null;
  function programarSync(ms) {
    clearTimeout(tSync);
    tSync = setTimeout(sincronizarFee, ms);
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[name="add"], [type="submit"][form*="product"]')) programarSync(1200);
    else if (e.target.closest('a.remove, [data-href*="/cart/change"], [class*="quantity"] button')) programarSync(1500);
  });

  // El tema vuelve a pintar el carrito y emite cart-updated: resincronizar.
  document.addEventListener('cart-updated', function () { programarSync(300); }, true);
  document.addEventListener('cart:refresh', function () { programarSync(300); }, true);

  // Bold cambia el plan sin recargar: escuchar el selector de suscripcion.
  document.addEventListener('change', function (e) {
    if (e.target.closest('[name="selling_plan"], [data-bsub-selling-plan-id-input], .bsub, [class*="subscription"]')) {
      programarSync(900);
    }
  }, true);

  // Bloquear clics sobre los controles del fee
  document.addEventListener('click', function (e) {
    var row = e.target.closest(SEL_FILA);
    if (row && esFilaDelFee(row)) {
      var ctrl = e.target.closest('button, a, [data-href]');
      if (ctrl) { e.preventDefault(); e.stopPropagation(); }
    }
  }, true);

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) programarSync(400);
  });

  // Comprobador manual: GT_DELIVERY_FEE.diagnostico('cherry')
  // Imprime como quedaria emparejado cada plan de esa bolsa con el del fee.
  async function diagnostico(handleBolsa) {
    var fee = await cargarFee();
    console.log('Fee: handle ' + FEE_HANDLE + ' | variante ' + FEE_VARIANT);
    console.table(fee.planes.map(function (p) {
      return { id: p.id, nombre: p.name, etiqueta: etiqueta(p) };
    }));

    if (!handleBolsa) return;
    var bolsa = await api('/products/' + handleBolsa + '.js');
    var filas = [];
    var grupos = bolsa.selling_plan_groups || [];
    for (var g = 0; g < grupos.length; g++) {
      var planes = grupos[g].selling_plans || [];
      for (var i = 0; i < planes.length; i++) {
        var destino = await resolverPlanFee(planes[i]);
        filas.push({
          planBolsa: planes[i].id,
          nombre: planes[i].name,
          planFee: destino || 'SIN PAREJA',
          ok: destino ? 'si' : 'NO'
        });
      }
    }
    console.table(filas);
  }

  window.GT_DELIVERY_FEE = {
    sync: sincronizarFee,
    zip: getZip,
    enZonaB: enZonaB,
    coherente: feeCoherente,
    planesFee: planesDelFee,
    diagnostico: diagnostico
  };
})();